import { Box, Grid, Typography } from '@mui/material'
import Style from '../../molecules/VenderModal/VendorModal.module.scss'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import { useSelector } from 'react-redux'

const defaultCover =
	'https://static.vecteezy.com/system/resources/previews/021/686/124/large_2x/blue-background-high-resolution-wallpaper-free-free-photo.jpg'

export const GetStartedModal = ({ setStep, formData, setFormData }) => {
    const accountType = useSelector((s) => s.auth.accountType)

	return (
		<>
			<Grid size={{ xs: 12, sm: 6 }}>
				<div className={Style.imageContainer}>
					<img src={defaultCover} alt="signup-img.jpg" />
				</div>
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }} className={`${Style.formContainer}`}>
				<Box
					sx={{
						textAlign: 'center',
						flex: 1,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						flexDirection: 'column',
					}}
					className={Style.titleContainer}
				>
					<Typography variant="h4">Lets complete</Typography>
					<Typography variant="body1">Your profile</Typography>
				</Box>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<ButtonCustom
						onClick={() => {
							setFormData({
								...formData,
								media: [],
								businessTypes: accountType === 'kazoo-planner' ? ['Wedding Planner'] : [],
								maxCapacity: 200,
								numEmployees: 100,
								instagramLink: '',
								tiktokLink: '',
								facebookLink: '',
                                websiteLink: ''
							})

                            if(accountType === 'kazoo-planner'){
                                return setStep((step) => step + 2)
                            }
                            setStep((step) => step + 1)
						}}
					>
						Let's Go!
					</ButtonCustom>
				</Box>
			</Grid>
		</>
	)
}
